import { render, staticRenderFns } from "./ShipperAfiliasiDetail.vue?vue&type=template&id=f3455292"
import script from "./ShipperAfiliasiDetail.vue?vue&type=script&lang=js"
export * from "./ShipperAfiliasiDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipperAfiliasiDetail.vue?vue&type=style&index=0&id=f3455292&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports